export default {
  name: "EditSolid",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "m19.38 19.69 8.21-8.21V27a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6.41c0-1.1.9-2 2-2h15.52l-8.21 8.21a2.98 2.98 0 0 0-.84 1.64l-.54 3.33a3.02 3.02 0 0 0 3.45 3.48l3.36-.54c.62-.1 1.2-.4 1.64-.84zm9.05-16.12a2.05 2.05 0 0 0-2.82-.01L14.43 14.74l-.54 3.33c.02.02.02.03.01.04l3.36-.54L28.44 6.38c.75-.71.73-2.1-.01-2.81z",
  },
}
